import { createSlice } from '@reduxjs/toolkit';
import { jobConfigurationInitialState } from '../initialStates/jobConfiguration';
import { CATEGORIES } from '../../../shared/const/TestConfiguration/FieldSettings';
import { FUSE_EDIT_TABLE } from '../../../shared/const/GenericTableParams/TestConfigurationTables';

const setProjectFeatures = (state, action) => {
  state.features = action.payload.features;
};

const setProjectReleases = (state, action) => {
  state.features = action.payload.features;
};

const setProjectSelectionMainProjects = (state, action) => {
  state.projectSelection.mainProjects = action.payload.mainProjects;
};

const setProjectSelectionSubProjects = (state, action) => {
  state.projectSelection.subProjects = action.payload.subProjects;
};

const setModelSelectionFilters = (state, action) => {
  state.modelSelection.filters = action.payload.filters;
};

const setModelSelectionReleases = (state, action) => {
  state.modelSelection.releases = action.payload.releases;
};

const setModelSelectionSelectedRelease = (state, action) => {
  if (action.payload.selectedRelease == state.modelSelection.selectedRelease) {
    state.modelSelection.selectedRelease = null;
    return;
  }
  state.modelSelection.selectedRelease = action.payload.selectedRelease;
};

const setTargetSelectionTargets = (state, action) => {
  state.targetSelection.targets = action.payload.targets;
};

const setTargetSelectionSelectedTarget = (state, action) => {
  if (action.payload.selectedTarget == state.targetSelection.selectedTarget) {
    state.targetSelection.selectedTarget = null;
    return;
  }
  state.targetSelection.selectedTarget = action.payload.selectedTarget;
};

const setTestConfigFields = (state, action) => {
  state.testConfiguration.fields = action.payload.fields;
};

const setTestConfigDynamicFields = (state, action) => {
  state.testConfiguration.dynamicFields = action.payload.fields;
};

const setTestConfigFieldValue = (state, action) => {
  const { category, field, value } = action.payload;
  state.testConfiguration.fields[category][field].value = value;
};

const setTestConfigFieldError = (state, action) => {
  const { category, field, error } = action.payload;
  state.testConfiguration.fields[category][field].error = error;
};

const setTestConfigDynamicFieldValue = (state, action) => {
  const { category, field, value } = action.payload;
  state.testConfiguration.dynamicFields[category].testFields[field].value =
    value;
};

const setTestConfigFuses = (state, action) => {
  state.testConfiguration.fuses = action.payload.fuses;
};

const setTestConfigStraps = (state, action) => {
  state.testConfiguration.straps = action.payload.straps;
};

const updateFuses = (state, action) => {
  const update = action.payload;
  Object.keys(update).forEach(id => {
    const idx = state.testConfiguration.fuses.findIndex(fuse => fuse.id == id);
    state.testConfiguration.fuses[idx] = update[id];
  });
};

const setTestConfigFieldValues = (state, action) => {
  const fieldValues = action.payload;
  const categories = [
    CATEGORIES.MAIN_SETTINGS,
    CATEGORIES.COMMANDS,
    CATEGORIES.TEST_CONTENT,
  ];
  Object.keys(fieldValues).forEach(category => {
    if (
      categories.includes(category) &&
      !state.testConfiguration.fields[category]
    ) {
      state.testConfiguration.fields[category] = {};
    }
    Object.keys(fieldValues[category]).forEach(fieldName => {
      const value = fieldValues[category][fieldName];
      if (Object.keys(state.testConfiguration.fields).includes(category)) {
        if (!state.testConfiguration.fields[category][fieldName]) {
          state.testConfiguration.fields[category][fieldName] = {};
        }
        state.testConfiguration.fields[category][fieldName].value = value;
      } else if (
        Object.keys(state.testConfiguration.dynamicFields).includes(category)
      ) {
        state.testConfiguration.dynamicFields[category].testFields[
          fieldName
        ].value = value;
      } else {
        // Handle fuses/straps
        const entryIndex = state.testConfiguration[category].findIndex(
          row => row[FUSE_EDIT_TABLE.searchColumnName] == fieldName
        );
        state.testConfiguration[category][entryIndex][
          FUSE_EDIT_TABLE.editColumnName
        ] = value;
      }
    });
  });
};

const setListFileContent = (state, action) => {
  const fileContent = action.payload;
  state.summary.listFileContent = fileContent;
};

const jobConfigurationSlice = createSlice({
  name: 'jobConfiguration',
  initialState: jobConfigurationInitialState,
  reducers: {
    setProjectFeatures,
    setProjectReleases,
    setProjectSelectionMainProjects,
    setProjectSelectionSubProjects,
    setModelSelectionFilters,
    setModelSelectionReleases,
    setModelSelectionSelectedRelease,
    setTargetSelectionTargets,
    setTargetSelectionSelectedTarget,
    setTestConfigFields,
    setTestConfigDynamicFields,
    setTestConfigFieldValue,
    setTestConfigFieldError,
    setTestConfigDynamicFieldValue,
    setTestConfigFuses,
    setTestConfigStraps,
    updateFuses,
    setTestConfigFieldValues,
    setListFileContent,
  },
});

export const jobConfigurationActions = jobConfigurationSlice.actions;

export default jobConfigurationSlice.reducer;
